import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-4">
              <i className="ri-smartphone-line"></i>
              全平台覆盖
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">移动观影</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              {appData.subtitle}
            </p>
            <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto lg:mx-0">
              {appData.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-50 border border-background-200/50">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/15 flex-shrink-0">
                    <i className="ri-check-line text-xs text-primary-400"></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-600">{feat}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px]">
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-primary-500/10 via-transparent to-accent-500/10 blur-2xl"></div>
              <div className="relative rounded-2xl border border-background-300/40 bg-background-50 overflow-hidden">
                <div className="aspect-[9/16] relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20dark%20cinema%20streaming%20app%20interface%20with%20movie%20posters%20grid%2C%20warm%20golden%20accent%20colors%2C%20clean%20minimal%20UI%20design%2C%20floating%20phone%20on%20dark%20gradient%20background%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20elegant%20and%20modern%20aesthetic&width=900&height=1600&seq=mobile-cinema-app&orientation=portrait"
                    alt="久播影院移动端观影体验"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent"></div>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-3 px-4 py-3 rounded-xl bg-background-100/90 backdrop-blur-sm border border-background-300/40">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500">
                      <i className="ri-play-circle-fill text-xl text-background-50"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs font-semibold text-foreground-800">久播影院</div>
                      <div className="text-[10px] text-foreground-500">全设备自适应 · 随时随地看</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}